import request from '@/utils/request'

const shop = {
  state: {
    shop_domain_prefix: ''
  },

  // const getters = {
  //   shop_domain_prefix: state => {
  //     return state.shop_domain_prefix
  //   }
  // }

  actions: {
    SetShopBasic({ commit, state }) {
      return new Promise((resolve, reject) => {
        request
          .get('basic')
          .then(response => {
            var shop_domain_prefix = ''
            if (response.data.shop_domain_prefix) {
              shop_domain_prefix = response.data.shop_domain_prefix
            }
            commit('SET_SHOP_DOMAIN_PREFIX', shop_domain_prefix)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  },

  mutations: {
    SET_SHOP_DOMAIN_PREFIX: (state, data) => {
      state.shop_domain_prefix = data
    }
  }
}

export default shop
